
import * as React from 'react';
import { ColumnWidth, createColumn } from '../createColumn';
import { IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import { Facet } from '../../../models/Facet';
import ColumnStrings from '../columns.resx';
import { fileSizeFacet, folderFacet } from '../../../facets/ItemFacets';
import { FileSizeField } from '../../fields/fileSize/FileSizeField';
import { IItemCache } from '../../../models/IItemCacheObserver';
import { countFacet } from '../../../facets/GroupFacets';
import { BaseText } from '../../fields/baseText/BaseTextField';
import { getLocalizedCountValue, format } from '@ms/utilities-strings/lib/index';
import ItemStrings from '../../../models/items/ItemStrings.resx';
import { getConfiguration } from '../../../models/configuration/getConfiguration';
import { enableItemCountInFileSizeColumnFacet } from '../../../facets/ConfigurationFacets';

export const fileSizeColumn: IColumn = createColumn({
  key: new Facet('fileSizeColumn').id,
  name: ColumnStrings.FileSize,
  fieldName: '',
  minWidth: ColumnWidth.regularMin,
  maxWidth: ColumnWidth.regularMax,
  isCollapsable: true
}, (props: {
  content: JSX.Element | null;
}): JSX.Element | null => {
    return props.content;
  })((itemCache: IItemCache, itemKey: string) => {
    const fileSize = itemCache.demandItemFacet(fileSizeFacet, itemKey);

    const {
      enableItemCountInFileSizeColumn
    } = getConfiguration(itemCache, {
      enableItemCountInFileSizeColumn: enableItemCountInFileSizeColumnFacet
    });

    if (typeof fileSize === 'undefined' && enableItemCountInFileSizeColumn) {
      const folder = itemCache.demandItemFacet(folderFacet, itemKey);

      if (folder) {
        const count = itemCache.demandItemFacet(countFacet, itemKey);

        if (typeof count !== 'undefined') {
          return {
            content: (
              <BaseText
                text={ format(getLocalizedCountValue(ItemStrings.itemCountFormat, ItemStrings.itemCountIntervals, count) || '', count) }
              />
            )
          };
        }
      }
    }

    return {
      content: (
        <FileSizeField
          size={ fileSize }
        />
      )
    };
  });
